import useTranslation from 'next-translate/useTranslation';

import { LinkSocial } from '@core/component';
import { Translate } from '@core/constant';
import { useFullUrl } from '@core/hook';
import { EIcon } from '@core/type';
import { facebookShareUrl, linkeinShareUrl, mailShareUrl, twitterShareUrl } from '@core/util';

import { getEnvironmentPublic } from '../../helpers';

export const BlogSocialLinks = ({ title, subtitle }: { title: string; subtitle: string }) => {
  const { host } = getEnvironmentPublic();
  const { fullUrl } = useFullUrl(host);
  const { t } = useTranslation(Translate.page.BLOG_ARTICLE);

  return (
    <>
      <LinkSocial
        type={EIcon.FACEBOOK}
        href={facebookShareUrl(title, fullUrl)}
        content={t('facebook')}
      />
      <LinkSocial
        type={EIcon.TWITTER}
        href={twitterShareUrl(title, fullUrl)}
        content={t('twitter')}
      />
      <LinkSocial type={EIcon.LINKED_IN} href={linkeinShareUrl(fullUrl)} content={t('linkedIn')} />
      <LinkSocial
        type={EIcon.EMAIL}
        href={mailShareUrl(t('emailBodyText'), title, subtitle, fullUrl)}
        width={'18px'}
        height={'14px'}
        content={t('email')}
      />
    </>
  );
};
